import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getFeaturedSubscriptionPlan, getTrialPlan } from '../../../../store/slices/paymentsSlice';
import PaymentButton, { paymentBtnType } from '../../../common/PaymentButton';
import styles from '../styles.module.scss';

const TrialPaymentContent = () => {
    const { t } = useTranslation();
    const trialDays = useSelector(getTrialPlan)?.period?.days;
    const date = DateTime.now().plus({ days: trialDays }).toFormat('LLLL d');
    const plan = useSelector(getFeaturedSubscriptionPlan);
    const planDays = plan?.period?.days;
    const planPrice = plan?.price;
    const price = planPrice?.currency?.symbol + planPrice?.value || '';

    return (
        <>
            <h2 className={styles.title}>{t('pages.payment.title1', { trialDays })}</h2>
            <p className={styles.text}>{t('pages.payment.label1')}</p>
            <PaymentButton text={t('buttons.freeTrial', { trialDays })} type={paymentBtnType.trial} googleEvent={'chatPopup'} />
            <p className={styles.price}>{t('pages.payment.priceOn', { price, date, planDays })}</p>
        </>
    );
};

export default TrialPaymentContent;
